import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper, childVariants } from './SectionWrapper';
export function WhyFailedSection() {
  return <SectionWrapper alternate data-id="element-342">
      <motion.h2 className="font-heading text-2xl md:text-3xl font-bold text-cream mb-4" variants={childVariants} data-id="element-343">
        Why what you've tried failed
      </motion.h2>

      <motion.p className="font-heading text-lg text-cream-muted italic mb-10" variants={childVariants} data-id="element-344">
        (and it's not your fault)
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-8" variants={childVariants} data-id="element-345">
        Because most solutions:
      </motion.p>

      <motion.ul className="space-y-5 mb-10" variants={childVariants} data-id="element-346">
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-347">
          Focus on sleep , not middle-of-the-night wake-ups
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-348">
          <span className="mt-2 w-2 h-2 rounded-full bg-amber flex-shrink-0" data-id="element-349" />
          <div data-id="element-350">
            <span data-id="element-351">Add more decisions</span>
            <br data-id="element-352" />
            <span className="text-cream-muted" data-id="element-353">
              ("try this… or this… or this…")
            </span>
          </div>
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-354">
          <span className="mt-2 w-2 h-2 rounded-full bg-amber flex-shrink-0" data-id="element-355" />
          <div data-id="element-356">
            <span data-id="element-357">
              Ignore the anxiety loop that begins the second you think:
            </span>
            <br data-id="element-358" />
            <em className="text-amber" data-id="element-359">"Oh no."</em>
          </div>
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-360">
          Accidentally train your brain that 3am = phone time,.
        </li>
      </motion.ul>

      <motion.p className="font-heading text-xl text-teal-light font-medium leading-relaxed-plus" variants={childVariants} data-id="element-361">
        This ebook reverses that training.
      </motion.p>
    </SectionWrapper>;
}